import React from "react";
import { Search } from "lucide-react";

interface ISubmitButtonProps {
  label: string; // Normal button label
  loadingLabel?: string; // Label when loading
  isLoading?: boolean; // Show spinner & disable
  onClick?: () => void; // Click handler
  type?: "button" | "submit"; // Type of button
  className?: string; // Custom styles
  showIcon?: boolean; // Show search icon
}

const SubmitButton: React.FC<ISubmitButtonProps> = ({
  label,
  loadingLabel = "Processing...",
  isLoading = false,
  onClick,
  type = "button",
  className = "",
  showIcon = false,
}) => {
  return (
    <button
      type={type}
      disabled={isLoading}
      onClick={onClick}
      className={`w-full h-[51px] bg-coral-pink-500 hover:bg-coral-pink-500 
        disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium 
        text-sm rounded-lg transition-all duration-200 transform 
        hover:scale-[1.02] active:scale-[0.98] ${className}`}
    >
      {isLoading ? (
        <div className="flex items-center justify-center gap-2">
          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>{loadingLabel}</span>
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2">
          {showIcon && <Search size={18} />}
          <span>{label}</span>
        </div>
      )}
    </button>
  );
};

export default SubmitButton;
